import toast from 'react-hot-toast';

export const notify = {
  success: (msg: string) => toast.success(msg),
  error: (msg: string) => toast.error(msg),
  apiError: (err: unknown, fallback = 'Произошла ошибка') => {
    const message = (err as any)?.response?.data?.error?.message || fallback;
    toast.error(message);
  },
};
